// Lux - Final Spark: fires a laser beam in a straight line from caster through
// the nearest enemy, crossing the entire map and dealing magic damage to every
// enemy it passes through.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const luxFinalSpark: Ability = {
  id: "luxFinalSpark",
  displayName: "Final Spark",
  description:
    "Lux fires a laser beam through the nearest enemy, dealing magic damage to all enemies in its path across the entire field.",
  iconId: "LuxFinalSpark",

  targetShape({ caster, combat }) {
    // Return all enemy positions so VFX covers the full beam sweep
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(enemyTeam).map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(enemyTeam);
    const stats = effectiveStats(caster);
    const dmg = magicDamage(stats.ap * 2.2 + 104);
    return enemies.map((unit, i) => ({
      target: unit,
      amount: dmg,
      type: "magical" as const,
      luxBeam: true,
      suppressPopup: i > 0,
    }));
  },
};
